export const colorText = () => {
  // @todo Would be nicer to dump the TW colors to JSON and import them here
  const colors = ['#FF692E', '#00359E', '#EA0060']

  const positions = ['-0.1ex', '-0.3ex', '-0.1ex', '0.1ex']

  let currentColorIndex = -1;

  // @todo - update ckeditor to add a data-attribute when text is highlighted
  [...document.querySelectorAll('.highlight')].forEach((node) => {
    const coloredText = [...node.innerHTML].reduce((previousChar, currentChar, index) =>
      previousChar + `<span style="color:${colors[++currentColorIndex % colors.length]}; animation-delay: ${(index * .35) +'s'}">${currentChar}</span>`, '',
    )

    node.innerHTML = coloredText

    currentColorIndex = -1
  })
}
